/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AffiliatedProfiles } from '../../models/affiliated-profiles';

export interface ListAffiliatedProfilesInGroupForProfile$Params {
  id: number;
}

export function listAffiliatedProfilesInGroupForProfile(http: HttpClient, rootUrl: string, params: ListAffiliatedProfilesInGroupForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<AffiliatedProfiles>> {
  const rb = new RequestBuilder(rootUrl, listAffiliatedProfilesInGroupForProfile.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AffiliatedProfiles>;
    })
  );
}

listAffiliatedProfilesInGroupForProfile.PATH = '/rest/profile/{id}/affiliated';
